
class DashboardClass {
    
    static dashboard_root_route = "/profile/dashboard/"
    
    static login_routes:any = {
        "LoginStep1": "/login?step=1",
        "LoginStep2": "/login?step=2",
        "LoginStep3": "/login?step=3",
        "LoginStep4": "/login?step=4",
        "ResetPin": "/reset-pin",
    }
    
    static dashboard_routes = {
        "Home": "/home",
        "Login": "/login",
        "NewCredit": "/new-credit",
        "ApplyCredit": "/apply-credit",
        "StandartCredit": "/standart-credit",
        "CreditLine": "/credit-line",
        "NewCreditLine":"new-credit-line",
        "Settings":"/settings",
        "Credit": "/credit",
        "CrLineLoan": "/credit-line-loan",
        "ApplyCrLine": "/apply-credit-line",
        "Success": "/success",
        "SuccessOpenCrLine": "/success-open-cr-line",
        "ConfirmIdentity": "/confirm-identity",
        "ConfirmIdentitySMS": "/conf-identity-sms",
        "page_404":"/404",
        "Locations":"/locations",
        "Office": "/office",
        "Banks":"/banks",
        "Bank":"/bank",
        "PendingLoans":"/pending-loans",
        "PaymentMethods":"/payment-methods",
        "Account": "/account",
        "KYC": "/kyc",
        "Promotions": `/promotions`,
        "Promo": "/promo",
        "SuccessKYC": "/success-kyc",
        "SuccessCr": "/success-cr",
        "KYCWaitingRoom": "/kyc-processing",
        "SignContract": "/sign-contract",
        "SignCrLineContract": "/sign-cr-line-contract",
        "SuccessApplyCrLine": "/success-cr-line-apply",
        "CrLineTransaction": "/cr-line-transaction",
        "SuccessCrLineSign": "/success-cr-line-sign"
    }
    
    static local_storage_objects = {

    }
    
    static is_mobile = false
    
}

export default DashboardClass